/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Subscription Icon component.
 */
export const SubscriptionIcon = (props: IconProps) => {
  const {color = dlsColor('grey3'), size = 24} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 16 14" fill={iconColor} xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4062 5.375L13.375 1.8125C13.0625 0.75 12.0938 0 10.9688 0H5C3.875 0 2.90625 0.75 2.59375 1.8125L1.5625 5.375C0.625 5.875 0 6.875 0 8V13.5C0 13.7812 0.21875 14 0.46875 14C0.75 14 0.96875 13.7812 0.96875 13.5V12H14.9688V13.5C14.9688 13.7812 15.2188 14 15.4688 14C15.75 14 15.9688 13.7812 15.9688 13.5V8C15.9688 6.875 15.3438 5.875 14.4062 5.375ZM3.5625 2.09375C3.71875 1.46875 4.3125 1 5 1H10.9688C11.625 1 12.2188 1.46875 12.4062 2.09375L13.25 5.03125C13.1562 5.03125 13.0625 5 12.9688 5H2.96875C2.875 5 2.8125 5.03125 2.71875 5.03125L3.5625 2.09375ZM14.9688 10C14.9688 10.5625 14.5312 11 13.9688 11H1.96875C1.4375 11 0.96875 10.5625 0.96875 10V8C0.96875 6.90625 1.875 6 2.96875 6H12.9688C14.0938 6 14.9688 6.90625 14.9688 8V10ZM3.21875 7.5C2.8125 7.5 2.46875 7.84375 2.46875 8.25C2.46875 8.6875 2.8125 9 3.21875 9C3.65625 9 3.96875 8.6875 3.96875 8.25C3.96875 7.84375 3.65625 7.5 3.21875 7.5ZM12.7188 7.5C12.3125 7.5 11.9688 7.84375 11.9688 8.25C11.9688 8.6875 12.3125 9 12.7188 9C13.1562 9 13.4688 8.6875 13.4688 8.25C13.4688 7.84375 13.1562 7.5 12.7188 7.5Z" fill={iconColor}/>
    </svg>

  );
};
